import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import {
	Cart,
	ChooseWeddingList,
	EmptyData,
	NewShopItems,
	PageTitleNavigation,
	ShopItem,
	SplitPane,
} from "../../components";
import MainLayout from "../../components/MainLayout/MainLayout";
import { Badge, Image, Modal, Popconfirm, Skeleton, Space } from "antd";
import { FloatBtn, hideScrollbar } from "../../lib/styles/styleLibrary";
import { isEmpty } from "../../lib/helpers/helpers";
import { useMediaQuery } from "react-responsive";
import cart from "../../assets/images/cart.png";
import Auth from "../../lib/middleware/auth";
import Currency from "../../components/Currency/Currency";
import CurrencyFormat from "react-currency-format";
import { useFetchShopItems } from "../../redux/api/shopHooks";
import { useCouplesData } from "../../redux/api/WeddingAPI";
import { NodeIndexOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { useMutation } from "react-query";
import { deleteShopItem } from "../../redux/actions/shop";
import {
	// useFetchCartItems,
	useFetchSelectedCartItems,
} from "../../redux/api/cartAPI";
import { ReactComponent as Del } from "../../assets/svg/del.svg";

const Wrapper = styled.div`
	${tw`p-5 pb-0! `}
	height: 80vh;
	.btnStyle {
		font-size: 0.75rem;
		font-family: "Poppins";
		border: "1px solid #f4f4f8" !important;
	}

	.delBg {
		${tw`h-9 w-9`}
		background: rgb(255, 255, 255, 0.6);
		/* border: 1px solid #ffffff; */
		box-sizing: border-box;
		border-radius: 50%;
	}
`;

const ShopItemWrapper = styled.div`
	${tw`w-full h-auto overflow-y-auto! relative`}
`;

const Shop = (props) => {
	const experience = Auth.getExperience();
	const user = Auth.getUser();
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const { data: coupleData } = useCouplesData();
	const [visible, setVisible] = useState(false);
	const [viewItem, setViewItem] = useState(false);
	const [showCartModal, setShowCartModal] = useState(false);
	const [selectedItem, setSelectedItem] = useState({});
	const [showModal, setShowModal] = useState(false);
	const [guestcouple, setGuestCouple] = useState({});
	const [couple, setCouple] = useState({});
	const [isEdit, setIsEdit] = useState(false);
	const [singlecartData, setsinglecartData] = useState({});
	const [weddingID, setweddingID] = useState("");
	// const { data: cartData } = useFetchCartItems({ email: user?.email });
	const { data: scartData, refetch: refetchCart } = useFetchSelectedCartItems(
		{
			email: user?.email,
			weddingId: weddingID,
		}
	);

	const {
		data: shopItem,
		isLoading: loadingShopItems,
		refetch,
	} = useFetchShopItems({
		weddingID,
	});

	useEffect(() => {
		if (isEmpty(scartData?.cart?.cart_items)) {
			return;
		}
		setsinglecartData(scartData?.cart?.cart_items);
	}, [scartData]);

	useEffect(() => {
		if (experience === "guest" && isEmpty(guestcouple)) {
			setShowModal(true);
			return;
		}
		if (experience === "couple" && isEmpty(coupleData?.data)) {
			return;
		}
		experience === "couple"
			? setCouple(coupleData?.data)
			: setCouple(guestcouple);
	}, [experience, guestcouple, coupleData]);

	useEffect(() => {
		if (isEmpty(couple)) {
			return;
		}
		setweddingID(couple?.id);
		refetchCart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [couple]);

	useEffect(() => {
		// eslint-disable-next-line
	}, [selectedItem]);

	const { mutateAsync: delShopItem, isLoading: delloading } =
		useMutation(deleteShopItem);

	const handleDelete = async (data) => {
		console.log(data);
		try {
			const response = await delShopItem(data);
			console.log(response.data);
			const { hasError } = response.data;
			if (hasError) {
				return;
			}
			setViewItem(false);
			refetch();
		} catch (err) {
			// return errorHandler(err);
		}
	};

	const MyShopItems = () => {
		return (
			<ShopItemWrapper css={hideScrollbar}>
				{loadingShopItems || delloading ? (
					<div tw="h-full w-full flex items-center gap-4 flex-wrap">
						{Array.apply(null, Array(4)).map((i) => {
							return (
								<Space direction="vertical" size={10}>
									<Skeleton.Button
										active
										size="large"
										shape="square"
										tw="h-48! w-40!"
									/>
									<Skeleton.Button
										active
										size="small"
										shape="round"
										tw="w-full!"
									/>
								</Space>
							);
						})}
					</div>
				) : isEmpty(shopItem) ? (
					<div tw="h-full w-full flex items-center justify-center">
						<EmptyData
							description={
								<span>
									If you attend a wedding, <br />
									you can shop their 'aso-ebi' and other items
									up for sale. <br />
									Search for a couple...
								</span>
							}
						/>
					</div>
				) : (
					<div tw="flex flex-row flex-wrap gap-8 container mt-4 justify-around md:justify-start w-full h-full">
						{shopItem?.map((item, i) => {
							return (
								<div
									tw="relative  w-full md:w-48 "
									key={i}
									style={{ minHeight: "12rem" }}
									onClick={() => setSelectedItem(item)}>
									<div tw="w-full md:w-48 h-72 md:h-44">
										<Image
											preview={false}
											src={
												item?.shop_item_images[0]
													?.media_url || cart
											}
											alt={item.name}
											width={"100%"}
											height={"100%"}
											tw="rounded-2xl shadow-md bg-gray-200"
											onClick={() => setViewItem(true)}
											placeholder={
												<Image
													preview={false}
													src={
														item
															?.shop_item_images[0]
															?.media_url_min ||
														cart
													}
													width={200}
												/>
											}
										/>
									</div>
									<div>
										<div tw="mt-2 flex flex-row items-center justify-between flex-wrap">
											<h4 tw="font-semibold opacity-50 text-sm">
												{item.name}
											</h4>
											{experience === "couple" && (
												<Popconfirm
													placement="top"
													title={
														"Do you wish to delete this item?"
													}
													onConfirm={() => {
														handleDelete(item?.id);
													}}
													okText="Yes"
													cancelText="No">
													<Del tw=" bg-appLightPink rounded-md hover:(shadow-md cursor-pointer)" />
												</Popconfirm>
											)}
										</div>{" "}
										<div tw="flex flex-row-reverse flex-wrap items-center justify-between">
											<span
												tw="text-appGreenGauze"
												style={{ fontSize: "10px" }}>
												{item.quantity_sold}/
												{item.quantity_provided}
											</span>
											<div tw="font-semibold text-sm">
												<CurrencyFormat
													value={item.price}
													allowNegative={false}
													displayType={"text"}
													thousandSeparator={true}
													type="tel"
													fixedDecimalScale={true}
													prefix={"₦"}
												/>
											</div>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				)}
			</ShopItemWrapper>
		);
	};

	return (
		<MainLayout>
			<Wrapper>
				<PageTitleNavigation
					title={"My Shop"}
					showBack
					tw="flex flex-row! items-center justify-between">
					<div tw="flex flex-row items-center gap-2">
						<Badge count={singlecartData?.length}>
							<ShoppingCartOutlined
								onClick={() => {
									setShowCartModal(true);
								}}
								tw="flex items-center justify-center text-2xl m-0! p-0! hover:(opacity-90 cursor-pointer shadow text-2xl rounded-full)"
							/>
						</Badge>
						{experience === "guest" && !isEmpty(weddingID) && (
							<Popconfirm
								placement="bottom"
								title={"Select a different Wedding shop"}
								onConfirm={() => {
									setShowModal(true);
									setsinglecartData({});
								}}
								okText="Switch"
								cancelText="Cancel">
								<NodeIndexOutlined tw="flex items-center justify-center text-2xl m-0! p-0! ml-4! hover:(opacity-90 cursor-pointer shadow text-2xl rounded-full)" />
							</Popconfirm>
						)}
						<Currency changeUserDefault={true} />
					</div>
				</PageTitleNavigation>

				<SplitPane
					wrapDirection={"column"}
					hideRightSide={isMobile}
					mainHeightAdjust={isMobile ? "10rem" : "0rem"}
					leftHeightAdjust={isMobile ? "20rem" : "10rem"}
					// rightHeightAdjust={isMobile ? "0rem" : "12rem"}
					left={<MyShopItems />}
					right={
						experience === "couple" && (
							<NewShopItems
								weddingID={weddingID}
								couple={couple}
								hideOnMobile={true}
							/>
						)
					}
				/>
				<Modal
					footer=""
					visible={visible}
					centered
					onCancel={() => setVisible(false)}
					maskClosable={false}>
					<NewShopItems
						weddingID={weddingID}
						couple={couple}
						shopDetails={selectedItem}
						hideOnMobile={false}
						setVisible={() => setVisible()}
						setIsEdit={(v) => {
							setIsEdit(v);
						}}
						refetch={() => refetch()}
						item={selectedItem}
						isEdit={isEdit}
					/>
				</Modal>

				{/* View item  modal */}
				<Modal
					footer=""
					visible={viewItem}
					width={isMobile ? "100%" : "50%"}
					centered
					afterClose={() => {
						refetch();
					}}
					onCancel={() => setViewItem(false)}
					maskClosable={false}>
					<ShopItem
						item={selectedItem}
						togView={(v) => setViewItem(v)}
						setIsEdit={(v) => setIsEdit(v)}
						setEditVisible={(v) => {
							setVisible(v);
						}}
						handleDelete={(v) => handleDelete(v)}
					/>
				</Modal>
				{/* End of view item modal */}

				<ChooseWeddingList
					showModal={showModal}
					setShowModal={() => setShowModal()}
					setWeddingDetails={(v) => setGuestCouple(v)}
				/>

				<Cart
					showModal={showCartModal}
					setShowModal={(v) => setShowCartModal(v)}
					setWeddingDetails={(v) => setGuestCouple(v)}
					weddingID={weddingID}
					email={user?.email}
					cartData={singlecartData}
				/>
			</Wrapper>
			{experience === "couple" && (
				<FloatBtn
					onClick={() => {
						setIsEdit(false);
						setVisible(true);
					}}>
					+
				</FloatBtn>
			)}
		</MainLayout>
	);
};

export default Shop;
